<div class="container-fluid h-100">
  <div class="row">
    <div class="col-12">
      <span class="title">{{ content.title }}</span>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="access-card-holder" (click)="onRedirect('PostJob')" (mouseover)="onMouseOver('PostJob')" (mouseout)="onMouseOut('PostJob')">
        <div class="access-card-icon-holder">
          <img [src]="currentPostJobImage" class="access-card-img" alt="Post Job">
          <span class="access-card-label">Post Job</span>
        </div>
        <span class="access-card-link-label">View All</span>
      </div>
      <div class="access-card-holder" (click)="onRedirect('CreateReq')" (mouseover)="onMouseOver('CreateReq')" (mouseout)="onMouseOut('CreateReq')">
        <div class="access-card-icon-holder">
          <img [src]="currentCreateReqImage" class="access-card-img" alt="Create Requisitions">
          <span class="access-card-label">Manage Requisitions</span>
        </div>
        <span class="access-card-link-label">View All</span>
      </div>
      <div class="access-card-holder" (click)="onRedirect('InterviewProcess')" (mouseover)="onMouseOver('InterviewProcess')"
        (mouseout)="onMouseOut('InterviewProcess')">
        <div class="access-card-icon-holder">
          <img [src]="currentInterviewProcessImage" class="access-card-img" alt="Interview Process">
          <span class="access-card-label">Interview Process</span>
        </div>
        <span class="access-card-link-label">View All</span>
      </div>
    </div>
  </div>
</div>
